module.exports = __webpack_public_path__ + "img/customerLogo11.6dc2157e.png";